import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lp-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './lp-navbar.component.html',
  styleUrl: './lp-navbar.component.css'
})
export class LpNavbarComponent {
  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }
}
